export class UserDetail {
  constructor(userDetail) {
    this.collaboratorList = userDetail.collaborators
    this.email = userDetail.email
    this.technicalId = userDetail.technical_id
    this.networkId = userDetail.network_id
    this.networkLogo = userDetail.network.logo
    this.storeList = userDetail.store_list
    this.permissionList = userDetail.permissions
    this.hasSeveralCollaborators = userDetail.has_several_collaborators
    this.phoneNumber = userDetail.phone_number
    this.roleList = userDetail.roles
    this.status = userDetail.status
  }
}
